import Plyr from "plyr";
import Isotope from "isotope-layout";
import "jquery-touchswipe";
import DisableScroll from "disable-scroll";

import ScrollMagic from "scrollmagic";

export default {
    init() {
        // JavaScript to be fired on the home page

    },
    finalize() {
        // JavaScript to be fired on the home page, after the init JS

    },
    onLoad() {
        let tag_controller = new ScrollMagic.Controller();
        let tag_scene;

        const $gallery = $(".gallery-container");
        if ($gallery.length > 0) {

            $gallery.imagesLoaded().progress(function () {
                new Isotope(".gallery-container", {
                    itemSelector: ".gallery-item",
                    percentPosition: true,
                    masonry: {
                        columnWidth: ".grid-sizer",
                    },
                });
            });

            $gallery.imagesLoaded().done(function () {

                if ($(".flexible-element").height() - $(".desktop-pinned").height() > 0 && $(window).width() > 991) {

                    tag_controller.removeScene(tag_scene);
                    tag_scene = new ScrollMagic.Scene({
                        triggerElement: "#pinner-start",
                        triggerHook: "onLeave",
                        duration: $(".flexible-element").height(),
                    })
                        .setPin(".desktop-pinned", {pushfollowers: false})
                        //.addIndicators()
                        .addTo(tag_controller);
                }

            });

            /*$("#lightbox").on("show.bs.modal", function (e) {

                DisableScroll.on();

                let $lightboxImage = $(this).find("img");
                let $currentImage = $(e.relatedTarget);
                $lightboxImage.attr("src", $currentImage.attr("src"));

                $lightboxImage.parent().on("animationend", function (e) {
                    $(e.delegateTarget).removeClass();
                });

                function next() {
                    if ($currentImage.parent().next().children().length > 0) {
                        $lightboxImage.parent().removeClass();
                        $currentImage = $currentImage.parent().next().children();
                        $lightboxImage.attr("src", $currentImage.attr("src"));
                        $lightboxImage.parent().addClass("animated slideInLeft");
                    } else {
                        $lightboxImage.parent().addClass("animated shake");
                    }
                }

                function prev() {
                    if ($currentImage.parent().prev().children().length > 0) {
                        $lightboxImage.parent().removeClass();
                        $currentImage = $currentImage.parent().prev().children();
                        $lightboxImage.attr("src", $currentImage.attr("src"));
                        $lightboxImage.parent().addClass("animated slideInRight");
                    } else {
                        $lightboxImage.parent().addClass("animated shake");
                    }
                }

                $(".next").on("click", function () {
                    next();
                });

                $(".prev").on("click", function () {
                    prev();
                });

                $(document).swipe({
                    swipeLeft: function () {
                        next();
                    },
                    swipeRight: function () {
                        prev();
                    },
                });

                $(document).keydown(function (ev) {

                    if (ev.key == "ArrowRight") {
                        next();
                        ev.preventDefault();
                    }
                    if (ev.key == "ArrowLeft") {
                        prev();
                        ev.preventDefault();
                    }
                    if (ev.key == "Escape") {
                        $("#lightbox").modal("hide");
                        ev.preventDefault();
                    }
                });

                $("#lightbox").on("hidden.bs.modal", function () {
                    DisableScroll.off();
                    $(document).off("keydown");
                    $(document).swipe("destroy");
                    $lightboxImage.off("animationend");
                    $(".next").off("click");
                    $(".prev").off("click");
                });

            });*/
            $(document).ready(function(){
                $("a.gallery-colorbox").colorbox({
                    rel: "school-gallery",
                    previous: "<i class = \"fal fa-chevron-left\"></i>",
                    next: "<i class = \"fal fa-chevron-right\"></i>",
                    close: "<i class = \"fal fa-times\"></i>",
                    maxWidth: "80%",
                    maxHeight: "80%",
                });

            });

        }

        if ($(".plyr__video-embed").length > 0) {
            Plyr.setup(".plyr__video-embed");
        }

    },
};



// WEBPACK FOOTER //
// ./scripts/routes/single.js